import { makeAutoObservable } from 'mobx';
import { RootStore } from './RootStore';

export class ModalStore {
  isOpen = false;

  modalName = '';

  modalConfirm = () => {};

  constructor(private _: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  showModal = (currentModalName: string, modalConfirm?: VoidFunction) => {
    this.isOpen = true;
    this.modalName = currentModalName;
    this.modalConfirm = modalConfirm ?? (() => {});
  };

  hideModal = () => {
    this.isOpen = false;
  };
}
